import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import generalStyles from './style/general.css';

export default function CardBody({ children, isHovered }) {
  const wrapProps = {
    className: cx(generalStyles.header, {
      'opacity-0': !isHovered,
      'opacity-100': isHovered,
    }),
  };

  return (
    <div {...wrapProps}>
      <div className={generalStyles.overlay} />
      {isHovered && <div>{children}</div>}
    </div>
  );
}

CardBody.propTypes = {
  children: PropTypes.node.isRequired,
  isHovered: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./packages/marvel-ui-card/CardBody/index.js